<div class="layout-container d-block d-md-flex">
  <bn-web-ui-topbar (onLogout)="logout()" />
  <div
    bnWebUiDroppable
    class="container-fluid g-0 layout-container__content d-block d-md-flex">
    <div class="row g-0 layout-container__main-row">
      <div class="col-auto">
        <bn-dashboard-sidebar
          #bnSidebar
          [isMobileMenuOpened]="isMobileMenuOpened"
          (toggleMenu)="onToggleMenu($event)" />
      </div>
      <div class="col bn-min-width bn-background-gradient--{{ contentService.containerBackgroundGradient() }}">
        @if (shouldShowNegativeBalanceBanner()) {
          <div
            class="negative-balance-banner"
            data-e2e="NegativeBalanceAlert">
            <div class="negative-balance-banner__content">
              <div class="negative-balance-banner__icon">
                <fa-icon icon="circle-exclamation" />
              </div>
              <span class="negative-balance-banner__text"
                ><strong>You have a negative balance.</strong> To keep your services running smoothly, please top up your account.</span
              >
              <button
                bn-web-ui-button
                itemStyle="secondary"
                size="md"
                (click)="topUpAccount()">
                Top Up Your Account
              </button>
            </div>
          </div>
        }

        <section
          class="bn-container {{ 'bn-container--' + contentService.containerSize() }}"
          [ngClass]="{
            'bn-container--disabled-transition': contentService.isTransitionDisabled(),
          }">
          <router-outlet />
        </section>
      </div>
    </div>
  </div>
  <bn-web-ui-central-widget />
  @if ((versionCheckService.showUpdateNotification$ | async) || false) {
    <bn-update-notification />
  }
  <bn-survey-widget />
</div>
<bn-layout-mobile-menu
  #bnMobileMenu
  [isMobileMenuOpened]="isMobileMenuOpened"
  [menuItems]="mobileMenuItems"
  (toggleMenu)="onToggleMenu($event)" />
